import Client from './client';

export default class AlertRequeueSummaries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(db, options = {}) {
    return this.makeRequest(`${this.host}/internal/stats/events/failures/${db}/requeue`, {
      ...options,
       method: 'POST',
    });
  }

}
